import React from 'react';
import clx from 'classnames';
import { Layout, BackTop } from 'antd';
const { Content } = Layout;
import { HeaderAdmin } from './HeaderAdmin';
import './AdminLayout.scss';
import { useThemeConfig } from 'client/components/schema/config/ClientConfigModule';

export interface AdminLayoutProps {
  children: React.ReactNode;
  isLogin?: boolean;
}

/**
 * Layout principale dell'area amministrazione dell'applicativo.
 * Contiene il menu principale.
 */
export function AdminLayout(props: AdminLayoutProps) {
  const { options } = useThemeConfig();

  return (
    <Layout
      className={clx('admin-layout', {})}
    >
      <HeaderAdmin isLogin={props.isLogin} />
      <Content className="admin-content">{props.children}</Content>
      <BackTop className="admin-back-top" />
    </Layout>
  );
}
